import { useSetAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { SimulationContext, simulationContextAtom } from "./atoms";

/**
 * Match a category code against available category keys (exact, then case-insensitive).
 * Used by MerchflowReview to pre-fill category from simulation.
 */
export const matchCategoryKey = (
  categoryCode: string,
  availableKeys: string[],
): string | undefined => {
  if (availableKeys.includes(categoryCode)) return categoryCode;
  return availableKeys.find((key) => key.toLowerCase() === categoryCode.toLowerCase());
};

export const useSimulationMerchflowModal = () => {
  const { openModal } = useModals();
  const setSimulationContext = useSetAtom(simulationContextAtom);

  const openMerchflowReviewWithSimulation = (context: SimulationContext) => {
    setSimulationContext(context);
    openModal("ModalMerchflowReview");
  };

  const clearSimulationContext = () => {
    setSimulationContext(null);
  };

  return {
    openMerchflowReviewWithSimulation,
    clearSimulationContext,
  };
};
